import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../Utils/Cards/card-component.js";
import CodeSnippet from "../../Utils/CodeSnippet/code-snippet-component.js";
import DropDown from "../../Utils/DropDown/drop-down-component.js";
import Navbar from "../../Utils/Navbar/navbar-component.js";
import { Modal } from "../../Utils/Modal/modal-component.js";
import { LoadingAnimation } from "../../Utils/Progress/progress-component.js";
import { ServerEndpoint } from "../../Redux/endpoints.ts";
import { post } from "../../Services/ApiService.js";
import { useNavigate } from "react-router";
import reciploLogo from '../../Assets/Logo01.png'
import courseData from "../../Public/course-data.js";
import OverlappingCards from "../../Components/overlapping-course-component.js";
import CourseCard from "../../Utils/Cards/course-card-component.js";
import './Courses.css'


function Courses() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const freeText = useRef(null);
    const loading = useSelector((state) => state.loading);
    const user = useSelector((state) => state.auth.user);
    const [gptResponse, setGptResponse] = useState(null);
    const [gptAuthorized, setGptAuthorized] = useState(null);
    const [promptMessage, setPromptMessage] = useState(null);
    const [gptLoading, setGptLoading] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [expandCourse, setExpandCourse] = useState(false);
    const [currentService, setCurrentService] = useState(undefined);
    const courseFormatters = courseData.getCourses();


    useEffect(() => {
        const userSubscription = user?.subscription_id;
        setGptAuthorized(userSubscription !== null && userSubscription !== 1);
    }, [user]);

    const handleRequestAction = async (e) => {
        e.preventDefault();
        setGptLoading(true);
        const content = await promptGPT({ prompt: promptMessage });
        setGptResponse(content);
        setGptLoading(false);
    };


    const handleSelectedRecipe = async (course) => {
        const courseData = courseFormatters[course[0]]
        setSelectedCourse(courseData);
        setExpandCourse(true);
    };

    const handleCardChangeAPI = async (serviceAdapter) => {
        const selectedService = parseInt(serviceAdapter[0]);
        await updateApiServie(selectedService);
    }

    const updateApiServie = async (service) => {
        // const apiRequestFormatted = await formatCodeTemplate(codeLanguagesTemplate[currentSelectedLanguage], targetService);
        // setCurrentService(targetService);
        // setApiServiceRequest(apiRequestFormatted);
    }


    const promptGPT = async (promptRequest) => {
        try {
            const response = await post(`${ServerEndpoint.RECIPLO_AI_PROMPT}`, promptRequest, true, 'Getting all services...');
            const content = response.data;
            console.log(content);
            if (content.status) {
                return content;
            }
        } catch (error) {
            console.log('Generate request failed');
        }
        return undefined;
    }

    if (loading.visible) {
        return <Modal>
            <LoadingAnimation loadingMessage={loading.message} />
        </Modal>
    }


    return (

        <div >
            {!gptAuthorized &&
                <Modal>
                    <div className="flex flex-col lg:w-full h-1/2 lg:h-1/3 w-5/6 justify-between max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 transition-all duration-200">
                        <div className="flex justify-end w-full" >
                            {/* <button onClick={(e) => { e.preventDefault(); }}>x</button> */}
                        </div>

                        <div className="text-lg text-gray-600 dark:text-gray-400 my-2">
                            You are currently using the Free Tier plan. To access reciplo-AI beta, please upgrade to a plan that provides AI services.
                        </div>
                        <div className="flex justify-center flex-col mb-2">
                            <button
                                onClick={(e) => { e.preventDefault(); navigate('/home') }}
                                className="button-component px-5 my-4" >upgrade plan</button>
                            <button
                                onClick={(e) => { e.preventDefault(); navigate('/') }}
                                className="w-full inline-flex justify-center text-sm items-center py-2 font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                                <svg className=" mr-2 -ml-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" strokeWidth="1.5" stroke="currentColor" ><path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" /></svg>
                                Go Back
                            </button>
                        </div>
                    </div>
                </Modal>
            }
            <div className="h-full w-full flex flex-row">
                <div className="min-h-full w-full">
                    <Navbar />
                    <main>
                        <CourseCard course={selectedCourse} close={() => { setExpandCourse(false) }} selected={expandCourse} />
                        <div className="relative flex-col bg-grey-50 items-center w-full h-full justify-center animate">
                            {/* <div className="fixed top-400 left-0 -z-50 w-full h-full">
                                <div className="relative flex-col my-20 bg-grey-50 items-center w-full h-full justify-center animate">
                                    <div className="relative w-full pointer-events-none h-screen">
                                        <div className="shape-blob"></div>
                                        <div className="shape-blob one"></div>
                                        <div className="shape-blob two"></div>
                                    </div>
                                </div>
                            </div>` */}

                            <div className="relative mx-auto w-screen py-6 sm:px-6 lg:px-8 bg-gray-100 dark:bg-black rounded-3xl transition-all duration-300">
                                <div className="px-4 py-6 sm:px-0">
                                    <div className="flex w-full justify-center">
                                           <h1 className="mb-4 text-6xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">ai gen studio</h1>
                                    </div>
                                    <div className="snap-start flex h-full w-full py-10 rounded-xl dark:bg-black bg-gray-50 flex-col items-center">
                                        <OverlappingCards courses={courseFormatters} trigger={handleSelectedRecipe} />
                                    </div>
                                    <div className="flex justify-center mb-10">
                                        <div className="flex justify-center flex-col">
                                            <div className="flex flex-col lg:flex-row lg:mb-5">
                                                <div className="flex flex-col lg:grid lg:grid-cols-3 lg:gap-4">

                                                </div>
                                            </div>
                                            <div className="flex flex-row justify-center my-4">
                                                {/* <DropDown buttonDrop={chooseLanguage} infoDrop={currentLanguage} bodyDrop={otherLanguages} /> */}
                                                {/* <DropDown buttonDrop={chooseApi} infoDrop={[currentService?.name, 'Choose Service']} bodyDrop={otherAPIS} /> */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="block justify-center">
                                        <form>
                                            <div className="mb-4 w-full items-center border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
                                                <div className="px-4 py-4 bg-white rounded-t-lg dark:bg-gray-800">
                                                    <textarea id="comment"
                                                        rows="5"
                                                        ref={freeText}
                                                        onChange={(e) => { e.preventDefault(); setPromptMessage(freeText?.current?.value) }}
                                                        className="w-full px-4 py-4 text-lg text-gray-900 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400" placeholder="Describe a recipe or provide a recipe url..." required></textarea>
                                                </div>
                                                <div className="flex items-center justify-between px-3 py-5 border-t dark:border-gray-600 " >
                                                    <button type="submit"
                                                        disabled={!gptAuthorized || gptLoading || !promptMessage || promptMessage.length === 0}
                                                        onClick={handleRequestAction}
                                                        className="inline-flex items-center py-3 px-7 text-md font-medium text-center text-white bg-blue-700  rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800 disabled:bg-blue-400 ">
                                                        {gptLoading ? 'Loading...' : 'Submit'}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div> */}
                                    {/* {gptResponse &&
                                        <div>
                                            <div className="flex h-max rounded-lg border-4 border-dashed border-gray-200 flex-col">
                                                <CodeSnippet info={gptResponse.data} allowCopy={true} allowProgressive={true} allowSkeleton={false} />
                                            </div>
                                        </div>
                                    } */}
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div >
        </div >

    );
}

export default Courses;